'use strict';

module.exports = ['widgets',
    function (widgets) {

        return {
            restrict: 'E',
            scope: {
                application: '=',
            },
            link: function (scope, element, attributes) {

                scope.$watch('application', function (newValue, oldValue) {

                    if (!newValue) {
                        return;
                    }

                    if (scope.application.settings_url) {
                        let remote_settings = scope.application.remote_settings;

                        let uniqueWidgetId = 'remote_settings_' + scope.application.id + '_' + scope.application.system_name;
                        widgets.createWidgetFrame(
                            uniqueWidgetId,
                            remote_settings,
                            undefined,
                            remote_settings.type,
                            (data, iframe) => {
                                switch (data.action) {

                                    case('height-update'):
                                        iframe.style.height = data.actionData.newHeight + 'px';
                                        break;

                                    case('save'):
                                        scope.$apply(() => {
                                            scope.application.settings = {
                                                ...data.actionData.content,
                                            };
                                        });
                                        break;

                                }
                            },
                            () => ([scope.application]),
                            {}, // @todo add extra data fields
                        ).then(iframe => {
                            iframe.id = 'settings';
                            iframe.className = 'custom-settings';
                            element.html(iframe);

                            scope.$on('$destroy', () => {
                                widgets.unRegisterWidget(uniqueWidgetId);
                            });
                        });
                    }
                });

            }
        };
    }
];

